import { SegmentValidationItem } from './segment-validation-item.interface';


export const validationStub: SegmentValidationItem[] = [
  {
    key: 'pies65',
    valid: true,
    title: 'PIES 6.5'
  }
];
